import Vue from "vue"
import { parseResponse } from "@reef-os/utils/api-utils"

let host = process.env.VUE_APP_API_HOST

const BASE_API = `https://orders${host}.2ndkitchen.com`
const BUSINESS_API = `https://business${host}.2ndkitchen.com`
const PRICING_API = `https://pricing${host}.2ndkitchen.com`
const DELIVERY_API = `https://delivery${host}.2ndkitchen.com`
const RESTAURANT_API = `https://restaurant${host}.2ndkitchen.com`
const FORKLIFT_API = `https://forklift${host}.2ndkitchen.com`
const USER_API = `https://user${host}.2ndkitchen.com`
const PAYMENT_API = `https://payment${host}.2ndkitchen.com`
const CAMPAIGN_API = `https://campaign${host}.2ndkitchen.com`
const NOTIFICATION_API = `https://notification${host}.2ndkitchen.com`
const SEARCH_API = `https://indexing${host}.2ndkitchen.com`
const AUTH_API = `https://auth${host}.2ndkitchen.com`
const FINANCE_API = `https://finance${host}.2ndkitchen.com`

export default {
	setGlobalHeaders() {
		Vue.axios.defaults.headers.common = {
			Authorization: `Bearer ${process.env.VUE_APP_API_ANON_TOKEN}`
		}
	},
	async getBusiness(business_slug) {
		return Vue.axios.get(
			`${BUSINESS_API}/businesses/${business_slug}?include=menus,tip_options,opening_hours,menu_payment_methods,delivery_modes,locations`
		)
	},
	async autocompleteBusinesses(query) {
		return parseResponse(
			Vue.axios.get(
				`${SEARCH_API}/businesses/autocomplete?name=${query}&fuzziness=1`
			)
		)
	},
	async getBusinessEvents(ids) {
		return parseResponse(Vue.axios.get(`${BUSINESS_API}/events?ids=${ids}`))
	},
	async getBusinessEvent(id) {
		return parseResponse(Vue.axios.get(`${BUSINESS_API}/events/${id}`))
	},
	async getMenu(business_id) {
		return Vue.axios.get(`${BASE_API}/business/${business_id}/menu`)
	},
	async getMenuProducts(menu_id, stock_status) {
		let url = `${RESTAURANT_API}/menus/${menu_id}/products`
		if (stock_status) {
			url += `?stock_status=${stock_status}`
		}
		return parseResponse(Vue.axios.get(url))
	},
	async getProductsByIds(ids) {
		return parseResponse(
			Vue.axios.get(`${RESTAURANT_API}/products?ids=${ids}`)
		)
	},
	async getItem(item_id) {
		return parseResponse(
			Vue.axios.get(`${RESTAURANT_API}/products/${item_id}`)
		)
	},
	async getRestaurants(rest_ids) {
		return parseResponse(
			Vue.axios.get(
				`${RESTAURANT_API}/restaurants?ids=${rest_ids}&include=opening_hours,opening_hours_exceptions`
			)
		)
	},
	async getRestaurantMenus(menu_ids) {
		return parseResponse(
			Vue.axios.get(`${RESTAURANT_API}/menus?ids=${menu_ids}`)
		)
	},
	async createOrder(payLoad) {
		return parseResponse(
			Vue.axios.post(`${BASE_API}/orders/create`, payLoad)
		)
	},
	async getOrderStatus(order_id) {
		return Vue.axios.get(`${BASE_API}/order_status/${order_id}`)
	},
	async getReceipt(order_id) {
		return Vue.axios.get(`${FINANCE_API}/orders/${order_id}/receipts`)
	},
	async calcDiscount(payload) {
		return parseResponse(
			Vue.axios.post(`${PRICING_API}/coupons/calc`, payload)
		)
	},
	async getCoupon(coupon_id) {
		return parseResponse(
			Vue.axios.get(`${PRICING_API}/coupons/${coupon_id}`)
		)
	},
	async getCouponUses(order_ids) {
		return parseResponse(
			Vue.axios.get(`${PRICING_API}/coupon_uses?order_ids=${order_ids}`)
		)
	},
	async getUserCoupons(user_id) {
		return parseResponse(
			Vue.axios.get(`${PRICING_API}/users/${user_id}/coupons`)
		)
	},
	async getDelivery(delivery_id) {
		return Vue.axios.get(`${DELIVERY_API}/deliveries/${delivery_id}`)
	},
	async getDeliveryStatus(delivery_id) {
		return parseResponse(
			Vue.axios.get(`${DELIVERY_API}/deliveries/${delivery_id}/job`)
		)
	},
	async getNearestBusinesses(lat, lon) {
		return parseResponse(
			Vue.axios.get(
				`${SEARCH_API}/businesses/closest?latitude=${lat}&longitude=${lon}&distance=2&limit=4`
			)
		)
	},
	async getOrderSession(order_session_id) {
		return parseResponse(
			Vue.axios.get(`${BASE_API}/order_session/${order_session_id}`)
		)
	},
	async sendEvent(payload) {
		return parseResponse(Vue.axios.post(`${FORKLIFT_API}/events`, payload))
	},
	async updateOrderStatus(order_id, status, payload) {
		return parseResponse(
			Vue.axios.put(
				`${BASE_API}/orders/${order_id}/status/${status}`,
				payload
			)
		)
	},
	async getCategories(ids) {
		return parseResponse(
			Vue.axios.get(`${RESTAURANT_API}/product_categories?ids=${ids}`)
		)
	},
	async authenticateUserViaSMS(payload) {
		return parseResponse(
			Vue.axios.post(`${AUTH_API}/authenticate/phone_number`, payload)
		)
	},
	async authenticateUserViaFacebook(payload) {
		return parseResponse(
			Vue.axios.post(`${AUTH_API}/authenticate/facebook`, payload)
		)
	},
	async authenticateUserViaGoogle(payload) {
		return parseResponse(
			Vue.axios.post(`${AUTH_API}/authenticate/google`, payload)
		)
	},
	async authenticateUserViaToken(payload) {
		return parseResponse(
			Vue.axios.post(`${AUTH_API}/verify_identity_token`, payload)
		)
	},
	async sendSMSVerificationCode(user_id, payload) {
		return parseResponse(
			Vue.axios.post(`${USER_API}/users/${user_id}/verify/v2`, payload)
		)
	},
	async verifyUser(user_id, payload) {
		return parseResponse(
			Vue.axios.post(
				`${USER_API}/users/${user_id}/verify_verification_code`,
				payload
			)
		)
	},
	async activateUser(user_id, payload) {
		return parseResponse(
			Vue.axios.post(`${USER_API}/users/${user_id}/activate`, payload)
		)
	},
	async updateUser(user_id, payload) {
		return parseResponse(
			Vue.axios.put(`${USER_API}/users/${user_id}/v2`, payload)
		)
	},
	async addUserNotification(user_id, payload) {
		return parseResponse(
			Vue.axios.post(
				`${USER_API}/users/${user_id}/notifications`,
				payload
			)
		)
	},
	async removeUserNotification(notification_id) {
		return parseResponse(
			Vue.axios.delete(
				`${USER_API}/user_notifications/${notification_id}`
			)
		)
	},
	async getUser(accessToken) {
		return parseResponse(
			Vue.axios.get(`${USER_API}/users/me`, {
				headers: { Authorization: `Bearer ${accessToken}` }
			})
		)
	},
	async getUserCampaigns(user_id) {
		return parseResponse(
			Vue.axios.get(`${CAMPAIGN_API}/users/${user_id}/campaigns_progress`)
		)
	},
	async getUserPaymentMethods(user_id) {
		return parseResponse(
			Vue.axios.get(`${PAYMENT_API}/users/${user_id}/payment_methods`)
		)
	},
	async getUserOrders(payload) {
		return parseResponse(
			Vue.axios.post(`${SEARCH_API}/orders/search`, payload)
		)
	},
	async addUserPaymentMethod(user_id, payload) {
		return parseResponse(
			Vue.axios.post(
				`${PAYMENT_API}/users/${user_id}/payment_methods`,
				payload
			)
		)
	},
	async updatePaymentMethod(payment_method_id, payload) {
		return parseResponse(
			Vue.axios.put(
				`${PAYMENT_API}/payment_methods/${payment_method_id}`,
				payload
			)
		)
	},
	async deleteUserPaymentMethod(payment_method_id) {
		return parseResponse(
			Vue.axios.delete(
				`${PAYMENT_API}/payment_methods/${payment_method_id}`
			)
		)
	},
	async sendNotification(payload) {
		return parseResponse(
			Vue.axios.post(`${NOTIFICATION_API}/notifications/send`, payload)
		)
	},
	async addBusinessEventReminder(event_id, payload) {
		return parseResponse(
			Vue.axios.post(
				`${BUSINESS_API}/events/${event_id}/user_reminders`,
				payload
			)
		)
	},
	async getBusinessVoucherRequests(business_id) {
		return parseResponse(
			Vue.axios.get(
				`${PRICING_API}/voucher_requests?business_ids=${business_id}`
			)
		)
	},
	async getBrands(ids) {
		return parseResponse(
			Vue.axios.get(`${RESTAURANT_API}/brands?brand_ids=${ids}`)
		)
	}
}
